const formatHoursToDate = (hours: number, minutes?: number) => {
	const formattedHours = hours < 10 ? `0${hours}` : hours
	const formattedMinutes =
		minutes && minutes < 10 ? `0${minutes}` : minutes || '00'

	return `${formattedHours}:${formattedMinutes}`
}

export default formatHoursToDate
